import { render, staticRenderFns } from "./SuperbillForm.vue?vue&type=template&id=56c683e2"
import script from "./SuperbillForm.vue?vue&type=script&lang=js"
export * from "./SuperbillForm.vue?vue&type=script&lang=js"
import style0 from "./SuperbillForm.vue?vue&type=style&index=0&id=56c683e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports